import React from "react";
import "./Gradient.css";

export default function Gradient() {
  return <div className="gradient"/>;
}
